<style scoped>
.this_input {
  width: 300px;
}
</style>
<template>
  <div class="demo__flex demo__flex-column demo__margin-top--16 demo__gap--24">
    <a-spin :spinning="loading">
      <p
        class="demo__font--16 demo__weight--400 demo__color--black demo__margin-bottom--24"
      >
        {{ $t("VerifyModal.step2.agenda") }}
      </p>
      <div
        v-if="form.professional_status === 3"
        class="demo__flex demo__flex-column demo__margin-bottom--16"
      >
        <span
          class="demo__font--16 demo__weight--400 demo__color--black demo__margin-bottom--0"
        >
          {{ $t("VerifyModal.step2.chooseVerifyWay") }}
        </span>
        <a-radio-group
          v-model="form.way"
          class="demo__VerifyModal--radioGroup-start"
        >
          <a-radio v-for="way in waysFields" :key="way.id" :value="way.id"
            ><p
              class="demo__margin-bottom--12 demo__word-break demo__text-wrap"
              v-bind:class="{
                'demo__width--300': isMobile,
                'demo__width--390': !isMobile,
              }"
            >
              {{ way.wayTitle }}
            </p>
            <div v-if="form.way === way.id">
              <UploadFile
                v-if="way.inputType === 'file'"
                v-model="form.files"
                :maxCount="1"
              />
              <a-input
                v-else
                v-model="form.link"
                class="demo__input this_input"
                :placeholder="$t('VerifyModal.step2.pasteLink')"
              />
            </div>
          </a-radio>
        </a-radio-group>
      </div>
      <div v-else-if="form.professional_status === 2">
        <span
          class="demo__StatusChoose--required demo__font--16 demo__weight--400 demo__margin-bottom--16"
        >
          {{ $t("VerifyModal.step2.ways.4") }}
        </span>
        <UploadFile v-model="form.files" />
      </div>
      <div v-else>
        <span
          class="demo__StatusChoose--required demo__font--16 demo__weight--400 demo__color--black demo__margin-bottom--16"
        >
          {{ $t("VerifyModal.step2.ways.5") }}
        </span>
        <UploadFile v-model="form.files" />
      </div>
      <div class="demo__flex demo__flex-row demo__flex-start">
        <a-button
          class="demo__button demo__button--base"
          @click="changeStepTo3"
          :disabled="nextStepDisabled"
          >{{ $t("VerifyModal.step2.sendToCheck") }}</a-button
        >
      </div>
      <div
        v-if="error"
        class="demo__font--14 demo__weight--600 demo__color--red"
      >
        {{ error }}
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import todo_statuses from "Locales/enEN/Verify.js";

import UploadFile from "./UploadFile";
export default {
  props: {
    form: {
      required: true,
      type: Object,
    },
  },
  components: {
    UploadFile,
  },
  watch: {
    "form.way"(newWay) {
      const selectedWay = this.waysFields.find((way) => way.id === newWay);
      if (selectedWay?.inputType === "file") {
        // Обнуляем только если текущее значение link не пустое
        if (this.form.link) this.$set(this.form, "link", undefined);
      } else {
        // Обнуляем только если уже есть файлы
        if (this.form.files && this.form.files.length)
          this.$set(this.form, "files", undefined);
      }
    },
  },
  data() {
    return {
      loading: false,
      ways: Object.values(todo_statuses.VerifyModal.step2.ways).slice(0, 3),
      error: undefined,
    };
  },
  methods: {
    async sendVerifyForm(data) {
      if (!data.professional_status) {
        return;
      }
      const formData = this.prepareFormData();
      this.loading = true;

      try {
        const res = await this.api.requestVerification({ data: formData });
        this.$store.dispatch("updateUser", {
          updateFieldOnly: {
            field: "current_verification",
            value: res.data.current_verification,
          },
        });
        this.$root.$emit("changeVerifyStep", 3);
      } catch (error) {
        this.error = error?.response?.data;
        this.$debug("Ошибка отправки:", "error", error);
      } finally {
        this.loading = false;
      }
    },
    prepareFormData() {
      const formData = new FormData();
      formData.append("professional_status", this.form.professional_status);

      if (this.form.link) {
        formData.append("link", this.form.link.trim());
      }

      if (this.form.files) {
        this.form.files.forEach((file) => {
          formData.append("files", file.raw || file);
        });
      }

      return formData;
    },
    changeStepTo3() {
      this.sendVerifyForm(this.form);
    },
  },
  computed: {
    ...mapGetters(["userLinks", "api", "user", "isMobile"]),
    nextStepDisabled() {
      if (this.form.professional_status === 3) {
        const currentWay = this.waysFields.find(
          (way) => way.id === this.form.way
        );
        if (!currentWay) return true; // Если способ не выбран

        if (currentWay.inputType === "file") {
          return !this.form.files?.length; // Проверяем наличие файлов
        } else {
          return !this.form.link?.trim(); // Проверяем наличие ссылки
        }
      }
      // Для статусов 2 и других проверяем только файлы
      return !this.form.files?.length;
    },
    waysFields() {
      return [
        {
          id: "diploma",
          wayTitle: this.$t("VerifyModal.step2.ways.1"),
          inputType: "file",
        },
        {
          id: "linkToProfile",
          wayTitle: this.$t("VerifyModal.step2.ways.2"),
          inputType: "text",
        },
        {
          id: "linkToClinic",
          wayTitle: this.$t("VerifyModal.step2.ways.3"),
          inputType: "text",
        },
      ];
    },
  },
  created() {
    this.$accessModule("VerifyModal_step2", this);
  },
};
</script>
